import { useMutation } from '@tanstack/react-query';
import { converters as filesConverters, useDownloadPdf } from 'store/files';
import { TransmissionActDocument } from 'containers/transmission-acts';
import { loaders } from './transmission-acts.loaders';
import { converters } from './transmission-acts.converters';

export const useExportToXls = () => {
  return useMutation(loaders.exportXls, {
    onSuccess: filesConverters.export,
  });
};

export const useDownloadTransmissionActPdf = () => {
  const { mutateAsync: downloadPdf } = useDownloadPdf();

  return useMutation(loaders.getTransmissionAct, {
    onSuccess: async (data) => {
      const transmissionAct = converters.getTransmissionAct(data);

      return downloadPdf({
        filename: `transmission-act-${
          transmissionAct.sequence || transmissionAct.id
        }.pdf`,
        document: <TransmissionActDocument transmissionAct={transmissionAct} />,
      });
    },
  });
};

export const useDownloadTransmissionActPdfOnServer = () => {
  return useMutation(loaders.downloadPdf, {
    onSuccess: filesConverters.export,
  });
};
